module.exports = __webpack_public_path__ + "static/img/as.9f80112b.svg";